import Spinner from './spinner.js';
export default Spinner;
